module.exports = __webpack_public_path__ + "img/logo.4677ea49.png";